import ImageMarker from '@/components/CustomComponent/ReactImageMarker';
import { COMMON_TEXT } from '@/helpers/common-text';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import { format } from 'date-fns';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/CustomComponent/LoadingSpinner';
import { DeviceStatusMarkerImageRender } from 'src/helpers/device-status-marker';
import { transformPositionToMarkerCoordinate } from 'src/helpers/utility';
import CustomCheckbox from 'src/components/CustomComponent/CustomCheckbox';
import './DeviceStatusOverviewNow.less';

@connect(state => ({
  querystring: state.querystring,
  sessionStore: state.session,
}))
class DeviceStatusOverviewNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data ?? [],
      dataTable: this.props.dataTable ?? [],
      floor:
        this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_FLOOR]?.[0],
      isLoading: this.props.isLoading ?? false,
      floorMapUrl: this.props.floorMapUrl ?? '',
      floorMapError: this.props.floorMapError ?? false,
      selectedDeviceModelList: this.props.selectedDeviceModelList ?? [],
      deviceModelOptions: this.props.deviceModelOptions ?? [],
      searchQuery: this.props.searchQuery ?? '',
      selectedFilters: this.props.selectedFilters ?? {},
      dropdownOpen: false,
    };

    this.dataTableRef = React.createRef();
    this.dropdownRef = React.createRef();
    this.filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      product: { value: null, matchMode: FilterMatchMode.CONTAINS },
      device_type: { value: null, matchMode: FilterMatchMode.CONTAINS },
      device_name: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS,
      },
    };

    this.mapZoomRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ dropdownOpen: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
    if (prevProps.dataTable !== this.props.dataTable) {
      this.setState({ dataTable: this.props.dataTable });
    }
    if (prevProps.isLoading !== this.props.isLoading) {
      this.setState({ isLoading: this.props.isLoading });
    }
    if (prevProps.floorMapUrl !== this.props.floorMapUrl) {
      this.setState({ floorMapUrl: this.props.floorMapUrl });
    }
    if (prevProps.floorMapError !== this.props.floorMapError) {
      this.setState({ floorMapError: this.props.floorMapError });
    }
    if (prevProps.selectedDeviceModelList !== this.props.selectedDeviceModelList) {
      this.setState({ selectedDeviceModelList: this.props.selectedDeviceModelList });
    }
    if (prevProps.deviceModelOptions !== this.props.deviceModelOptions) {
      this.setState({ deviceModelOptions: this.props.deviceModelOptions });
    }
    if (prevProps.searchQuery !== this.props.searchQuery) {
      this.setState({ searchQuery: this.props.searchQuery });
    }
    if (prevProps.selectedFilters !== this.props.selectedFilters) {
      this.setState({ selectedFilters: this.props.selectedFilters });
    }
  }

  renderStatusIcon = (dataItem) => {
    const { iconImage, status, product } = dataItem;

    // If iconImage is available and not 'default', show the actual device icon
    if (iconImage && iconImage !== 'default') {
      return (
        <div className="status-icon-container">
          <img
            src={iconImage}
            alt="device"
            width="24"
            height="24"
            style={{ objectFit: 'contain' }}
          />
        </div>
      );
    }

    var defaultIcon = '/assets/img/verkada-camera-icon.svg';
    if (product === 'Meraki') {
      defaultIcon = '/assets/img/meraki-wifi-icon.svg';
    }

    // If no icon image, show a default placeholder
    return (
      <div className="status-icon-container">
        <div
          style={{
            width: '24px',
            height: '24px',
            backgroundColor: status === 'offline' ? '#FF6E6E' : '#6BCE7A',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: '#666',
            border: '1px solid #fff'
          }}
        >
          <img
            src={defaultIcon}
            alt="device"
            width="15"
            height="15"
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>
    );
  };



  renderDataTable = () => {
    const { dataTable, isLoading, searchQuery, selectedFilters } = this.state;

    const filteredData = dataTable.filter(item => {
      if (!searchQuery) return true;
      const searchLower = searchQuery.toLowerCase();

      // Check which filters are selected and only search those columns
      const activeFilters = Object.keys(selectedFilters).filter(key => selectedFilters[key]);

      if (activeFilters.length === 0) {
        // If no filters are selected, search all columns
        return (
          item.product?.toLowerCase().includes(searchLower) ||
          item.device_type?.toLowerCase().includes(searchLower) ||
          item.device_name?.toLowerCase().includes(searchLower)
        );
      }

      // Search only in selected filter columns
      return activeFilters.some(filter => {
        switch (filter) {
          case 'product':
            return item.product?.toLowerCase().includes(searchLower);
          case 'device_type':
            return item.device_type?.toLowerCase().includes(searchLower);
          case 'device_name':
            return item.device_name?.toLowerCase().includes(searchLower);
          default:
            return false;
        }
      });
    });

    const statusBodyTemplate = (dataItem) => {
      return (
        <div style={{ textAlign: 'left', display: 'flex', justifyContent: 'flex-start' }}>
          {this.renderStatusIcon(dataItem)}
        </div>
      );
    };

    const productBodyTemplate = (dataItem) => {
      return (
        <div style={{ textAlign: 'left' }}>
          <span className="product-column">{dataItem.product || '-'}</span>
        </div>
      );
    };

    const typeBodyTemplate = (dataItem) => {
      return (
        <div style={{ textAlign: 'left' }}>
          <span className="type-column">{dataItem.device_type || '-'}</span>
        </div>
      );
    };

    const nameBodyTemplate = (dataItem) => {
      return (
        <div style={{ textAlign: 'left' }}>
          <span className="name-column">{dataItem.device_name || '-'}</span>
        </div>
      );
    };

    const updateBodyTemplate = (dataItem) => {
      // Use timestamp field which exists in the data
      const timestamp = dataItem.timestamp || dataItem.updated_at;
      if (!timestamp) return '-';

      const date = new Date(timestamp);
      return (
        <div className="update-column" style={{ textAlign: 'left' }}>
          <div>{format(date, 'M月d日')}</div>
          <div>{format(date, 'HH:mm')}</div>
        </div>
      );
    };

    return (
      <DataTable
        ref={this.dataTableRef}
        className="device-table"
        value={filteredData}
        scrollable
        loading={isLoading}
        emptyMessage={() => {
          return (
            <div className="flex justify-content-center align-items-center">
              <div className="no-data-container">
                {COMMON_TEXT.NO_DATA}
              </div>
            </div>
          );
        }}
      >
        <Column
          field="status"
          header="状態"
          body={statusBodyTemplate}
          className="status-column"
          headerStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
          bodyStyle={{ color: '#FFF', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
        />
        <Column
          field="product"
          header="プロダクト"
          body={productBodyTemplate}
          className="product-column"
          headerStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
          bodyStyle={{ color: '#FFF', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
        />
        <Column
          field="device_type"
          header="機種"
          body={typeBodyTemplate}
          className="type-column"
          headerStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
          bodyStyle={{ color: '#FFF', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
        />
        <Column
          field="device_name"
          header="名前"
          body={nameBodyTemplate}
          className="name-column"
          headerStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
          bodyStyle={{ color: '#FFF', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
        />
        <Column
          field="timestamp"
          header="更新日時"
          body={updateBodyTemplate}
          className="update-column"
          headerStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
          bodyStyle={{ color: '#A2A8BB', fontFamily: '"DM Sans"', fontSize: '12px', fontStyle: 'normal', fontWeight: '700', lineHeight: 'normal', padding: '4px 0px' }}
        />
      </DataTable>
    );
  };

  handleDeviceTypeChange = (option) => {
    const { selectedDeviceModelList } = this.state;
    const isSelected = selectedDeviceModelList.some(item => item.code === option.code);

    let newSelection;
    if (isSelected) {
      newSelection = selectedDeviceModelList.filter(item => item.code !== option.code);
    } else {
      newSelection = [...selectedDeviceModelList, option];
    }

    this.setState({ selectedDeviceModelList: newSelection });
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  render() {
    const {
      data: floorMapData,
      isLoading,
      floorMapUrl,
      floorMapError,
      selectedDeviceModelList,
      searchQuery,
      selectedFilters,
      deviceModelOptions,
      dropdownOpen,
    } = this.state;

    const { onSearchChange, onFilterChange } = this.props;

    let floorMapDataMarkers = floorMapData.map(item => {
      const marker = transformPositionToMarkerCoordinate(item.position);
      return {
        ...marker,
        item: item,
      };
    });

    const deviceModelSet = new Set(
      selectedDeviceModelList.map(item => item.code)
    );
    floorMapDataMarkers = floorMapDataMarkers.filter(item => {
      const deviceModel = item.item?.data?.device_type;
      return deviceModelSet.has(deviceModel);
    });

    if (isLoading) {
      return (
        <div className="device-status-content" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <LoadingSpinner />
        </div>
      );
    }

    return (
      <Fragment>
        <div className="data-panel">
          <div className="panel-header">
            <div className="search-bar">
              <img
                src="/assets/img/search-icon.svg"
                alt="Search"
                className="search-icon"
              />
              <InputText
                value={searchQuery}
                onChange={onSearchChange}
                placeholder="検索"
                className="search-input"
              />
            </div>

            <div className="filter-checkboxes">
              <CustomCheckbox
                inputId="filter-product"
                checked={selectedFilters.product}
                onChange={() => onFilterChange('product')}
                label="プロダクト"
              />
              <CustomCheckbox
                inputId="filter-model"
                checked={selectedFilters.device_type}
                onChange={() => onFilterChange('device_type')}
                label="機種"
              />
              <CustomCheckbox
                inputId="filter-name"
                checked={selectedFilters.device_name}
                onChange={() => onFilterChange('device_name')}
                label="名前"
              />
            </div>
          </div>
          <div className="sensor-table-container">
            {this.renderDataTable()}
          </div>
        </div>

        <div className='device-status-overview-now-map-container'>
          <div className="map-panel">
            <div className="map-controls">
              <div className="device-type-dropdown" ref={this.dropdownRef} onClick={this.toggleDropdown}>
                <span className="dropdown-label">
                  デバイス種類（{selectedDeviceModelList.length}）
                </span>
                <i className={`pi ${dropdownOpen ? 'pi-chevron-up' : 'pi-chevron-down'}`} />

                {dropdownOpen && (
                  <div className="dropdown-menu">
                    {deviceModelOptions.map(option => {
                      const isChecked = selectedDeviceModelList.some(item => item.code === option.code);
                      return (
                        <div
                          key={option.code}
                          className="dropdown-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDeviceTypeChange(option);
                          }}
                        >
                          <CustomCheckbox
                            inputId={`device-type-${option.code}`}
                            checked={isChecked}
                            onChange={(e) => {
                              e.stopPropagation();
                              this.handleDeviceTypeChange(option);
                            }}
                          />
                          <label
                            htmlFor={`device-type-${option.code}`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {option.name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div className="zoom-controls">
                <button
                  className="zoom-button zoom-out"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.zoomOut()}
                  type="button"
                >
                  <img src="/assets/img/zoom-out-icon.svg" alt="Zoom Out" />
                </button>
                <button
                  className="zoom-button zoom-fit"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.resetTransform()}
                  type="button"
                >
                  <img src="/assets/img/zoom-fit-icon.svg" alt="Zoom Fit" />
                </button>
                <button
                  className="zoom-button zoom-in"
                  onClick={() => this.mapZoomRef.current && this.mapZoomRef.current.zoomIn()}
                  type="button"
                >
                  <img src="/assets/img/zoom-in-icon.svg" alt="Zoom In" />
                </button>
              </div>
            </div>
            <div className="map-container">
              {floorMapError ? (
                <div className="flex align-items-center justify-content-center h-full">
                  <Message
                    severity="error"
                    text={COMMON_TEXT.CANNOT_LOAD_FLOORMAP}
                  />
                </div>
              ) : (
                <ImageMarker
                  extraClass="custom-image-marker"
                  bufferLeft={0}
                  bufferTop={0}
                  src={floorMapUrl}
                  markerComponent={DeviceStatusMarkerImageRender}
                  markers={floorMapDataMarkers || []}
                  alt=""
                  ref={this.mapZoomRef}
                />
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

DeviceStatusOverviewNow.propTypes = {};

export default DeviceStatusOverviewNow;
